import { defineStore } from "pinia";
import { ref } from "vue";

export const useUIStateStore = defineStore(
  "uiState",
  () => {
    const loading = ref(false);

    function toggleLoading() {
      loading.value = !loading.value;
    };
    function startLoading() {
      if (this.loading === false) {
        loading.value = true;
      }
    };
    function stopLoading() {
      if (this.loading === true) {
        loading.value = false;
      }
    };

    return { loading, startLoading, stopLoading };
  },
  {
    persist: false,
  },
);
